// freebetsFlow.js
import { sanitizeForCampaign } from "./freebetsCore.js";

export async function saveCampaignFlow({
                                           actions,
                                           payload,
                                           genBonusId,
                                           bonusPrefix = "",
                                           addPlayersSequential,
                                           onStage = () => {},
                                        }) {
    if (Array.isArray(payload)) {payload = JSON.parse(JSON.stringify(payload[0]));}
    const nextFrame = () => new Promise(requestAnimationFrame);
    const clone = sanitizeForCampaign(payload);
    const initialPlayers = Array.isArray(payload.playerList) ? payload.playerList.map(p => ({
        id: p.playerId ?? p.id,
        label: p.playerName ?? p.label ?? String(p.playerId ?? p.id)
    })) : [];
    let presetBonuses = null;
    if (initialPlayers.length > 0 && typeof actions.preflightProviderPlayers === "function") {
        onStage("preparing", { done:0, total:initialPlayers.length, errors:0 });
        await nextFrame();
        const { playersWithBonus } = await actions.preflightProviderPlayers({
            players: initialPlayers,
            campaign: payload,
            genBonusId,
            bonusPrefix
        });
        presetBonuses = new Map((playersWithBonus || []).map(r => [String(r.id), r.bonusCode]));
    }
    onStage("creating", { done:0, total: initialPlayers.length, errors:0 });
    await nextFrame();
    const res = await actions.createCampaignDoc(clone);
    const newCampaignId = res?.data?.campaignId ?? res?.data?.id ?? res?.data?.doc?.campaignId ?? clone.campaignId;
    const createdDoc = res?.data?.doc ?? res?.data ?? { ...clone, campaignId: newCampaignId };
    onStage("created", { done:0, total: initialPlayers.length, errors:0, campaignId: createdDoc });
    if (initialPlayers.length === 0) {
        onStage("done", { done:0, total:0, errors:0 });
        return { campaignId: newCampaignId, doc: createdDoc };
    }
    onStage("adding", { done:0, total:initialPlayers.length, errors:0 });
    try {
        if (typeof window !== 'undefined' && window.dispatchEvent) {
            window.dispatchEvent(new CustomEvent('campaign:created', { detail: createdDoc }));
        }
    } catch {}
    await addPlayersSequential({
        campaignId: newCampaignId,
        players: initialPlayers,
        genBonus: () => genBonusId(bonusPrefix || "", 12),
        addPlayers: async (cid, players) => {
            players = players.map(p => {
                const player = {...p};
                if (presetBonuses && presetBonuses.has(String(player.playerId))) {
                player.bonusCode = presetBonuses.get(String(player.playerId));
                player.__skipProvider = true;   // <<< bandera para que addPlayer NO llame al proveedor
            }
                return player;
            })
            
            return actions.addPlayer(cid, players);
        },
        
        onTick: ({ done, total, errors }) => onStage("adding", { done, total, errors }),
    });
    onStage("done", { done: initialPlayers.length, total: initialPlayers.length, errors: 0 });
    return { campaignId: newCampaignId, doc: createdDoc };
}
export function genBonusId(prefix = "", len = 12) {
    const pre = String(prefix || "");
    const sep = pre && !pre.endsWith("_") ? "_" : "";
    let s = "";
    while (s.length < len) s += Math.random().toString(36).slice(2);
    return `${pre}${sep}${s.slice(0, len).toUpperCase()}`;
}
export async function addPlayersSequential({ campaignId, players, genBonus, addPlayers, onTick }) {
    const total = Array.isArray(players) ? players.length : 0;
    let done = 0, errors = 0;
    const nextFrame = () => new Promise(requestAnimationFrame);
    const payload = players.map(pl => ({
        bonusCode: pl.bonusCode || genBonus(),
        playerId: pl.id || pl.playerId,
        playerName: pl.label || pl.playerName || String(pl.id || pl.playerId),
        playerStatus: 1
    }))
    let ok = true;
    try {
        await addPlayers(campaignId, payload);
    } catch {
        errors += 1; ok = false;
    } finally {
        done += 1;
        onTick && onTick({ done, total, errors, payload, ok });
        if (onTick) {
            const ret = onTick({ done, total, errors, payload, ok });
            if (ret && typeof ret.then === "function") {
                try { await ret; } catch {}
            }
        }
        await nextFrame();
    }
    return { done, total, errors };
}

